import { InfoAdapter } from "features/shared/types/info";
import { Tag } from "features/shared/types/tag";
import firebase from "firebase/app";
import "firebase/firestore";

import { AppThunk } from "services/redux/rootReducer";
import addOneLog from "features/panelManagement/logging/actions/set.addOneLog";

const updateOneTag =
    (
        key: string,
        params: {
            value: InfoAdapter;
        }
    ): AppThunk =>
    async (dispatch) => {
        const db = firebase.firestore();
        const docRef = db.collection("tags").doc(key);
        const previousData = ((await docRef.get()).data() as Tag).value;

        await docRef.update({
            value: {
                ...previousData,
                ...params.value,
            },
        });

        dispatch(
            addOneLog({
                eventInfo: {
                    description: `Updated one tag with key ${key}`,
                },
            })
        );

        return;
    };

export default updateOneTag;
